import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Checkbox } from "antd-mobile-v2";
import "./index.less";
import { edipData } from "./const";
import secsstion from "../../api/service/secsstion";
export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isbtn: true,
      NoticeTitle: "投诉须知",
      NoticeType: "complaint",
      push: "",
      orgName: "",
    };
  }
  componentDidMount() {
    let num = secsstion.get("token");
    if (!num) {
      this.props.history.push("/");
    }
    let ceptName = secsstion.get("qiYName");
    this.setState({ orgName: ceptName ? ceptName : "中国石化" });
  }

  onCkUrl = (item) => {
    if (item.type === "evaluate" || item.type === "userInfo") {
      this.props.history.push(item.push);
      return;
    }
    this.setState({
      visible: true,
      NoticeTitle: item.title,
      NoticeType: item.type,
      push: item.push,
    });
  };
  // 须知内容
  NoticeRender = () => {
    const { NoticeType } = this.state;
    switch (NoticeType) {
      case "complaint":
        return (
          <div>
            &nbsp;&nbsp;
            &nbsp;1.请准确选择“信访目的”和“事发地”，并将“主要诉求”“事实和理由”表述清楚，以便及时妥善处理。
            <br />
            &nbsp;&nbsp; &nbsp;2.每天只可提交1次投诉请求（意见建议）。
            <br />
            &nbsp;&nbsp;
            &nbsp;3.根据《信访工作条例》第二十六条规定，信访人应当遵守法律法规，不得损害国家、社会、集体的利益和其他公民的合法权利，自觉维护社会公共秩序和信访秩序。不得扰乱公共秩序、妨害国家和公共安全，不得使用攻击、谩骂等不文明语言，不得捏造歪曲事实、诬告陷害他人。
          </div>
        );
      case "proposal":
        return (
          <div>
            &nbsp;&nbsp;
            &nbsp;1.主要征集企业在安全环保、生产经营、改革发展、企业管理和队伍建设，以及有关推进党建工作、群团组织建设、维护员工群众利益等方面的意见或建议。
            <br />
            &nbsp;&nbsp; &nbsp;2.请准确填写
            “主要观点”和“具体建议”，所提意见建议应观点鲜明、有理有据、表达清晰、有针对性。
            <br />
            &nbsp;&nbsp; &nbsp;3.每天只可提交1次投诉请求（意见建议）。
            <br />
            &nbsp;&nbsp;
            &nbsp;4.请遵守法律法规，不得损害国家、社会、企业的利益和其他公民合法权利，自觉维护企业办公秩序和信访秩序。不得使用攻击、谩骂等不文明语言，不得捏造歪曲事实、诬告陷害他人。
            <br />
            &nbsp;&nbsp; &nbsp;5.如反映具体问题，请通过“投诉请求”提出。
          </div>
        );
      case "Notice":
        return (
          <div>
            <p>
              网上信访:
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;1．网上信访是指公民、法人或者其他组织通过中国石化网站、电子信箱、微信公众号等平台反映情况，提出建议、意见或者投诉请求，依法由有关机关、单位处理的活动。
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;2．根据《信访工作条例》第二十九、三十、三十一条规定，信访事项由有权处理机关、单位区分情况办理，其中属于《信访工作条例》第三十一条第六项规定的信访事项自受理之日起60日内办结；情况复杂的，延期30日办结。
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;3．依照《信访工作条例》的有关规定，中国石化信访部门不受理下列情况的事项：
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;（1）网上信访事项已经受理或者正在办理的，信访人在规定期限内（一般为60日）又提出同一信访事项的；
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;（2）已有处理（复查）意见且正在复查（复核）期限内，信访人再次提出相同信访事项的；
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;（3）对已有复核意见，信访人仍然以同一事实和理由提出投诉请求的；
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;另外，不受理匿名以及事实不清、责任主体不明的信访事项。
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;请您不要在法定期限内就同一信访事项重复网上信访。如已有处理（复查）意见，请及时向原办理机关、单位的上一级机关、单位申请复查（复核）。
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;感谢您的理解和支持！
            </p>
          </div>
        );
      default:
        return null;
    }
  };
  render() {
    const { NoticeType } = this.state;
    console.log(this.state.sub);
    return (
      <div className="home-wrapper">
        <div className="home-top"></div>
        <div className="login-text">{this.state.orgName}网上信访</div>
        <Modal
          visible={this.state.visible}
          transparent
          maskClosable={false}
          title={this.state.NoticeTitle}
          footer={[]}
          closable={true}
          onClose={() => {
            this.setState({
              visible: false,
              isbtn:true
            });
          }}
          className="Tips-cont"
        >
          <div className="Notice-center">
            {this.NoticeRender()}
            {NoticeType != "Notice" ? (
              <div className="modal-foter">
                <Checkbox
                  style={{ fontSize: "0.13rem", color: "#128EE9" }}
                  onChange={(e) => {
                    this.setState({ isbtn: !e.target.checked });
                  }}
                >
                  &nbsp;&nbsp;我承诺提出的信访事项客观真实，并对所提供材料内容的真实性负责。
                </Checkbox>
                <div className="foter-btn">
                  <Button
                    type="primary"
                    disabled={this.state.isbtn}
                    inline
                    size="small"
                    onClick={() => {
                      this.props.history.push(this.state.push);
                    }}
                  >
                    同意
                  </Button>
                  <Button
                    type="primary"
                    inline
                    size="small"
                    onClick={() => {
                      this.setState({
                        visible: false,
                        isbtn:true
                      });
                    }}
                  >
                    不同意
                  </Button>
                </div>
              </div>
            ) : null}
          </div>
        </Modal>

        <div className="center-wrap">
          {edipData.map((item) => {
            return (
              <div
                key={item.type}
                className="card-item"
                onClick={() => {
                  this.onCkUrl(item);
                }}
                style={{
                  background: `url(${item.url})`,
                  backgroundSize: "cover",
                }}
              ></div>
            );
          })}
        </div>
        <div
          className="Notice-cont"
          onClick={() => {
            this.setState({
              visible: true,
              NoticeTitle: "网上信访须知",
              NoticeType: "Notice",
            });
          }}
        >
          网上信访须知
        </div>
      </div>
    );
  }
}
